var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 13,
    viewBox: "0 0 40 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.687 4.13957C20.6642 5.94328 22.2906 6.94976 23.5158 7.54823C24.7745 8.16221 25.1973 8.55596 25.1923 9.1051C25.183 9.9454 24.1883 10.3163 23.2575 10.3307C21.6336 10.3559 20.6894 9.89121 19.9388 9.53974L19.3538 12.2837C20.1069 12.6315 21.5014 12.9349 22.9475 12.9482C26.342 12.9482 28.5628 11.2686 28.5748 8.66435C28.5881 5.35922 24.0142 5.17628 24.0455 3.69898C24.0563 3.25103 24.4827 2.773 25.417 2.65146C25.8795 2.59006 27.1562 2.54307 28.6037 3.21124L29.1719 0.556423C28.3934 0.272303 27.393 0.000242233 26.1473 0.000242233C22.9523 0.000242233 20.7052 1.70277 20.687 4.13957ZM34.6309 0.228917C34.0111 0.228917 33.4888 0.591351 33.2556 1.14753L28.4067 12.7532H31.7987L32.4738 10.8833H36.6188L37.0103 12.7532H40L37.3911 0.228917H34.6309ZM35.1055 3.61221L36.0844 8.31523H33.4034L35.1055 3.61221ZM16.5744 0.229074L13.9006 12.7531H17.133L19.8055 0.22876L16.5744 0.229074ZM11.7927 0.229074L8.42828 8.75347L7.06734 1.50527C6.90766 0.696134 6.27703 0.228917 5.57672 0.228917H0.0770312L0 0.592604C1.12906 0.838194 2.41188 1.2343 3.18906 1.65813C3.66469 1.91704 3.80031 2.14336 3.95656 2.75859L6.53422 12.7532H9.95L15.1869 0.228917L11.7927 0.229074Z",
    fill: "url(#paint0_linear_4975_6027)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4975_6027",
    x1: 1838.96,
    y1: 38.9219,
    x2: 1876.53,
    y2: -1290.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/VisaLogo.b0f86fbb34b429fb469ed58c4040615b.svg";
export { ForwardRef as ReactComponent };